function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.333 14.414l4.708-4.707-1.415-1.414-3.293 3.293-1.293-1.293-1.414 1.414 2.707 2.707zM4.333 22h16v-2h-16v2z",
  fill: "#A7AEB7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.92 2.586a2 2 0 012.828 0l6 6a2 2 0 010 2.828L14.161 18H8.505l-4.586-4.586a2 2 0 010-2.828l8-8zM13.332 4l6 6-6 6h-4l-4-4 8-8z",
  fill: "#F2F5F9"
});

var SvgParticipateInElections = function SvgParticipateInElections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjMzMzQgMTQuNDE0M0wxNi4wNDA1IDkuNzA3MThMMTQuNjI2MyA4LjI5Mjk3TDExLjMzMzQgMTEuNTg1OUwxMC4wNDA1IDEwLjI5M0w4LjYyNjI4IDExLjcwNzJMMTEuMzMzNCAxNC40MTQzWiIgZmlsbD0iI0E3QUVCNyIvPgo8cGF0aCBkPSJNNC4zMzMzMSAyMkgyMC4zMzMzVjIwSDQuMzMzMzFWMjJaIiBmaWxsPSIjQTdBRUI3Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuOTE5MSAyLjU4NTc5QzEyLjcwMDEgMS44MDQ3NCAxMy45NjY1IDEuODA0NzQgMTQuNzQ3NSAyLjU4NTc5TDIwLjc0NzUgOC41ODU3OUMyMS41Mjg2IDkuMzY2ODQgMjEuNTI4NiAxMC42MzMyIDIwLjc0NzUgMTEuNDE0MkwxNC4xNjE3IDE4SDguNTA0ODlMMy45MTkxIDEzLjQxNDJDMy4xMzgwNSAxMi42MzMyIDMuMTM4MDUgMTEuMzY2OCAzLjkxOTEgMTAuNTg1OEwxMS45MTkxIDIuNTg1NzlaTTEzLjMzMzMgNEwxOS4zMzMzIDEwTDEzLjMzMzMgMTZIOS4zMzMzMUw1LjMzMzMxIDEyTDEzLjMzMzMgNFoiIGZpbGw9IiNGMkY1RjkiLz4KPC9zdmc+Cg==";
export { SvgParticipateInElections as ReactComponent };